var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3184 19.4221L23.2656 16.8712C21.5813 16.0119 21.5242 16.5758 19.7543 18.348C19.3261 18.7777 18.5267 19.9054 17.5847 19.6906C15.6149 19.2341 11.9324 16.5221 10.7334 15.2869C10.1624 14.6962 7.70738 11.8768 7.67883 10.9638C7.62174 9.56752 10.8761 8.86937 9.81987 6.21105L7.56464 1.4583C5.45216 -3.1065 -0.457094 4.19717 0.0282069 7.60734C1.28428 16.0119 16.9566 29.5989 25.6921 25.1147C27.6333 24.0943 30.2596 20.523 28.3184 19.4221Z",
    fill: "#079D49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallActive);
export default __webpack_public_path__ + "static/media/call-active.9c21ef84aee0d290fc4bfd43a00fecbd.svg";
export { ForwardRef as ReactComponent };